import emitter from '../../../shared/mixin/emitter';

export default {
  name: 'UiFormRadio',

  mixins: [emitter],

  inheritAttrs: false,

  inject: {
    uiFormItem: {
      default: '',
    },
  },

  template: `
    <div :class="[
      'form-check',
      { 
        'form-check-inline': inline,
        'is-disabled': disabled,
      }
    ]">
      <label class="form-check-label">
        <input
          type="radio"
          class="form-check-input"
          :value="label"
          :disabled="disabled"
          v-model="model"
          @change="handleChange"
        />
        <slot></slot>
        <template v-if="!$slots.default">{{ label }}</template>
      </label>
    </div>
  `,

  props: {
    disabled: Boolean,
    value: {},
    label: {},
    inline: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.dispatch('UiFormItem', 'ui.form.change', val);
      },
    },
  },

  methods: {
    handleChange() {
      this.$nextTick(() => {
        this.$emit('change', this.model);
      });
    },
  },
};
